import { api } from './auth.service';

const tipoAtividadeService = {
  listar: async () => {
    const res = await api.get('/tipos-atividade');
    return res.data;
  },
};

export default tipoAtividadeService;
